import request from "@/utils/upload-request";
import ENDPOINT from "@/config/endpoint";

import fileServices from "./file";
import { convertPayloadData } from "@/utils/common";

async function upload(fileType, file) {
  const formData = new FormData();
  formData.append("files", file.raw);
  return await request({
    url: ENDPOINT.UPLOAD,
    method: "put",
    data: formData,
  })
    .then(async (res) => {
      const data = res._item[0];
      await fileServices.create(convertPayloadData("files", {
        based_type: "",
        based_id: "",
        video_type: "",
        object_type: "",
        content_type: "",
        file_type: fileType,
        url: data,
        size: file.size,
        locale: "vi",
        ordered: 0,
        extra: {
          name: file.name,
          author: file.name,
          description: file.name,
        },
      }));
    })
    .catch(() => {});
}

export default {
  upload,
};
